(function () {
  'use strict';

  document.querySelectorAll('.v2-pdp').forEach(function (root) {
    var trigger = root.querySelector('[data-zoom-trigger]');
    var lightbox = root.querySelector('[data-zoom-lightbox]');
    if (!trigger || !lightbox) return;

    var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-product-single-media-wrapper]'));
    var lightboxImage = lightbox.querySelector('[data-zoom-image]');
    var closeBtn = lightbox.querySelector('[data-zoom-close]');
    var prevBtn = lightbox.querySelector('[data-zoom-prev]');
    var nextBtn = lightbox.querySelector('[data-zoom-next]');
    var currentIndex = 0;

    function activeSlideIndex() {
      var rail = root.querySelector('[data-zoom-trigger]');
      var scrollLeft = rail.scrollLeft;
      var slideWidth = rail.clientWidth || 1;
      return Math.round(scrollLeft / slideWidth);
    }

    function showImage(index) {
      if (!mediaItems.length) return;
      currentIndex = (index + mediaItems.length) % mediaItems.length;
      var item = mediaItems[currentIndex];
      lightboxImage.src = item.getAttribute('data-zoom-full');
      lightboxImage.alt = item.getAttribute('data-zoom-alt') || '';
      lightboxImage.classList.remove('is-zoomed');
    }

    function openLightbox() {
      showImage(activeSlideIndex());
      lightbox.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function closeLightbox() {
      lightbox.hidden = true;
      document.documentElement.style.overflow = '';
    }

    trigger.addEventListener('click', function (evt) {
      if (trigger.dataset.dragged === 'true') {
        trigger.dataset.dragged = 'false';
        return;
      }
      openLightbox();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (prevBtn) prevBtn.addEventListener('click', function () { showImage(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showImage(currentIndex + 1); });

    lightbox.addEventListener('click', function (evt) {
      if (evt.target === lightbox) closeLightbox();
    });

    if (lightboxImage) {
      lightboxImage.addEventListener('click', function (evt) {
        evt.stopPropagation();
        lightboxImage.classList.toggle('is-zoomed');
      });
    }

    document.addEventListener('keydown', function (evt) {
      if (lightbox.hidden) return;
      if (evt.key === 'Escape') closeLightbox();
      if (evt.key === 'ArrowLeft') showImage(currentIndex - 1);
      if (evt.key === 'ArrowRight') showImage(currentIndex + 1);
    });

    var thumbsWrap = root.querySelector('[data-thumbs]');
    var thumbButtons = thumbsWrap
      ? Array.prototype.slice.call(thumbsWrap.querySelectorAll('[data-thumb-index]'))
      : [];

    function setActiveThumb(index) {
      thumbButtons.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === index);
      });
    }

    function goToSlide(index) {
      trigger.scrollTo({ left: index * trigger.clientWidth, behavior: 'smooth' });
    }

    thumbButtons.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        goToSlide(i);
        setActiveThumb(i);
      });
    });

    if (thumbButtons.length) {
      var railScrollTimer;
      trigger.addEventListener('scroll', function () {
        window.clearTimeout(railScrollTimer);
        railScrollTimer = window.setTimeout(function () {
          setActiveThumb(activeSlideIndex());
        }, 100);
      });
    }
  });
})();
